import { BaseInstruction } from './base.instruction';
// a type of instruction that can be used as base for non-functional / representative instructions
export class StaticInstruction extends BaseInstruction {
  constructor() {
    super(...arguments);
    this.isInput = false;
    this.useFieldWrapper = false;
  }
}